import { render, staticRenderFns } from "./AcoesLeilao.vue?vue&type=template&id=160af14a&scoped=true&"
import script from "./AcoesLeilao.vue?vue&type=script&lang=js&"
export * from "./AcoesLeilao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160af14a",
  null
  
)

export default component.exports